import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { StorageService } from '../_services/storage.service';
import { AuthService } from '../_services/auth.service';
import { LoginStorageKey } from './auth.constants';
@Injectable({
    providedIn: 'root'
  })
  export class SecurityGuard implements CanActivate {
    constructor(private router: Router, private storageService: StorageService,private authService : AuthService) {}
  
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
      console.debug('Inside TFA AUTH Guard',state.url);
      // Skip TFA check for auth routes
      if (state.url.includes('/auth/')) {
        return true;
      }
  
      const securityCheck = this.storageService.getForVerifyOTP(LoginStorageKey.SECURITY_VERIFICATION);
      const authToken = this.storageService.getToken();
 
    // if (securityCheck === 'Pending' && authToken) {
    //   if (!state.url.includes('/auth/tfa-setup')) {
    //     this.router.navigate(['/auth/tfa-setup']);
    //     return false;
    //   }
    //   return true;
    // }
      // Case 1: User has completed auth but not TFA
      if (securityCheck === 'Pending' && authToken) {
        if (!state.url.includes('/auth/otp-verification')) {
          this.router.navigate(['/auth/otp-verification']);
          return false;
        }
        return true;
      }

      if (state.url.includes('/auth/tfa-setup')) {

        if (authToken && securityCheck === 'pending-setup') {
          return true;
        }
        this.router.navigate(['/auth/login']);
        return false;
      }
  
      // Case 2: User has TFA markers but no auth token (invalid state)
      if (securityCheck && !authToken) {
        console.warn('Clearing invalid TFA state - missing auth token');
        this.authService.logout();
        return false;
      }
  
      // Case 3: Normal access - either no TFA required or already completed
      return true;
    }
  }